export const styles = {
  profileDrawer: {
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
};
